<template>
  <div :class="[wrapperClass + '-tile-list']">
    <div v-for="index in number" :key="index" class="checkout-tile">
      <div class="skeleton-loader">
        <div :class="['skeleton-mask', { 'square': isHorizontal }]"></div>
      </div>
    </div>
  </div>
</template>
<script src="./loader-animation.js"/>